<template>
  <div v-show="showModal">
    <div class="popup type02" v-bind:style="{ width: sizeY + 'px', top: posX + 'px', left: posY + 'px' }">
      <div class="popHead">
        <p class="title"><slot name="info"></slot></p>
      </div>
      <div class="popCont">
        <div class="inner">
          <slot name="content"></slot>
          <img :src="attachFile" />
        </div>
      </div>
      <div class="popBottom">
        <slot name="chkbox"></slot>
        <button class="btn close" @click="modalHide">닫기</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showModal: true,
      posX: '',
      posY: '',
      sizeX: '',
      sizeY: '',
      linkUrl: '',
      repoId: '',
      filePath: '',
      saveNm: '',
      fileEx: '',
      attachFile: '',
    };
  },
  methods: {
    modalHide() {
      this.showModal = false;
    },

    setProps() {
      if (this.propsData != null) {
        this.posX = this.propsData.posX;
        this.posY = this.propsData.posY;
        this.sizeX = this.propsData.sizeX;
        this.sizeY = this.propsData.sizeY;
        this.linkUrl = this.propsData.linkUrl;
        this.repoId = this.propsData.repoId;
        this.filePath = this.propsData.filePath;
        this.saveNm = this.propsData.saveNm;
        this.fileExt = this.propsData.fileExt;
        // repoId가 없는 경우 사진이 없는거라고 판단
        if (this.propsData.repoId != null) {
          this.attachFile =
            '/api/admin/popup/atchfile/' + this.repoId + '/' + this.filePath + '/' + this.saveNm + '.' + this.fileExt;
        }
      }
    },
  },
  props: ['propsData'],
  watch: {
    propsData: {
      handler() {
        this.setProps();
      },
    },
  },
  mounted() {
    this.setProps();
  },
};
</script>
